import { WebConferenceErrorCode } from "@api/enums/errors/WebConference";
import { WebConferenceErrorInterface } from "../interfaces/web-conference/WebConferenceErrorInterface";
export class WebConferenceError implements WebConferenceErrorInterface {
    constructor(public code: WebConferenceErrorCode) {
    }

    static isWebconferenceError(code: WebConferenceErrorCode | string) {
        const codes: string[] =
        [
            WebConferenceErrorCode.scheduleNotFound,
            WebConferenceErrorCode.wrongTime,
            WebConferenceErrorCode.banned
        ]

        return codes.includes(code);
    }
}
